import { memo } from 'react';
import { onSelectChangeAdapter, SelectInput, selectValueAdapter, TextInput } from '@intellecteu/common-ui';
import { handleIntegerInput } from 'app/utils';
import { Labels, memory } from 'app/constants';
import { ui } from 'ui/styles';
import { Field } from '../ui/form/field';

export const BackupSizeComponent = () => (
  <div className={ui.fieldGroup}>
    <Field
      className={ui.fieldGroupInput}
      component={TextInput}
      id="storage.backupSize.value"
      name="storage.backupSize.value"
      label={`${Labels.STORAGE_BACKUP_SIZE}*`}
      onKeyPress={handleIntegerInput}
    />
    <Field
      className={ui.fieldGroupSelect}
      options={memory}
      component={SelectInput}
      wrapperClassName={ui.fieldGroupSelectContainer}
      id="storage.backupSize.unit"
      name="storage.backupSize.unit"
      onChangeAdapter={onSelectChangeAdapter}
      valueAdapter={selectValueAdapter(memory)}
      maxMenuHeight="200px"
      isMenuAbove
    />
  </div>
);

export const StorageBackupSize = memo(BackupSizeComponent);
